import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import {
  ShipmentLoadStatusChainLoad,
  ShipmentLoadStatusChainSetInitialState,
} from './shipment-load-status-chain.actions';
import { ShipmentLoadStatusChainModel } from '../../models/shipment-load-status-chain.model';
import { ShipmentLoadStatusChainService } from './shipment-load-status-chain.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentLoadStatusChainStateModel {
  statusChain: ShipmentLoadStatusChainModel[];
  loaded: boolean;
}

const initialState: ShipmentLoadStatusChainStateModel = {
  statusChain: [],
  loaded: false,
};

@State<ShipmentLoadStatusChainStateModel>({
  name: 'shipmentLoadStatusChain',
  defaults: initialState,
})
@Injectable()
export class ShipmentLoadStatusChainState {
  constructor(
    private shipmentLoadStatusChainService: ShipmentLoadStatusChainService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getState(state: ShipmentLoadStatusChainStateModel): ShipmentLoadStatusChainStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentLoadStatusChainStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getStatusChainView(state: ShipmentLoadStatusChainStateModel): ShipmentLoadStatusChainModel[] {
    return state.statusChain;
  }

  @Action(ShipmentLoadStatusChainLoad)
  getLoadStatusChain(
    ctx: StateContext<ShipmentLoadStatusChainStateModel>,
    { payload }: ShipmentLoadStatusChainLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentLoadStatusChainService.getStatusChainData(payload).pipe(
      map(({ milestones }: { milestones: ShipmentLoadStatusChainModel[] }) => {
        ctx.patchState({ statusChain: milestones, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentLoadStatusChainSetInitialState)
  setInitialState(ctx: StateContext<ShipmentLoadStatusChainStateModel>): void {
    ctx.setState(initialState);
  }
}
